import gql from 'graphql-tag';

export const bookmark = gql`
  fragment BookmarkListItem on Bookmark {
    id
    name
    url
  }
`;
